import React from "react";
import { Link } from "wouter";

interface Location {
  id: number;
  name: string;
  address: string;
  phone: string;
  hours: string;
  mapUrl: string;
  embedUrl: string;
}

const locations: Location[] = [
  {
    id: 1,
    name: "Repair Store – North York (YorkgateMall)",
    address: "1 York Gate Blvd, North York, ON M3N 3A1, Canada",
    phone: "(647) 200-2040",
    hours: "Mon-Fri: 10am-8pm\nSat: 10am-6pm\nSun: 12pm-5pm",
    mapUrl: "https://www.google.com/maps/place/ZIWA+TECH+Computer+Cell+Phone+Store/@43.7590204,-79.5188099,17z/data=!3m1!4b1!4m6!3m5!1s0x882b316531644a63:0x2e755499ae48c95f!8m2!3d43.7590204!4d-79.5188099!16s%2Fg%2F11stz7p1qk",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2881.6665672208946!2d-79.5188099!3d43.7590204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b316531644a63%3A0x2e755499ae48c95f!2sZIWA%20TECH%20Computer%20Cell%20Phone%20Store!5e0!3m2!1sen!2s!4v1744030175245!5m2!1sen!2s"
  },
  {
    id: 2,
    name: "Mississauga Location",
    address: "50 Valley Blvd, Mississauga, ON L5A 3S2, Canada",
    phone: "(647) 200-2040",
    hours: "Mon-Fri: 10am-8pm\nSat: 10am-6pm\nSun: 12pm-5pm",
    mapUrl: "https://www.google.com/maps/place/5678+Sparkwell+Dr,+Mississauga,+ON+L5R+3N8/@43.6086079,-79.6864083,17z/data=!3m1!4b1!4m6!3m5!1s0xa8aed70628fe1d89:0x1b85972ec3d988b!8m2!3d43.6086079!4d-79.6864083!16s%2Fg%2F11ryq1m7w1",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d92444.8697635799!2d-79.76880899679688!3d43.608578308508974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0xa8aed70628fe1d89%3A0x1b85972ec3d988b!2s5678%20Sparkwell%20Dr%2C%20Mississauga%2C%20ON%20L5R%203N8%2C%20Canada!3m2!1d43.608607899999996!2d-79.6864083!5e0!3m2!1sen!2s!4v1744034047999!5m2!1sen!2s"
  }
];

const LocationCard = ({ location }: { location: Location }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
      <h3 className="text-xl font-semibold mb-2 text-gray-800">{location.name}</h3>
      <div className="mb-4 space-y-3">
        <div className="flex items-start">
          <svg className="w-5 h-5 text-primary mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
          <span className="text-gray-600">{location.address}</span>
        </div>
        <div className="flex items-start">
          <svg className="w-5 h-5 text-primary mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
          </svg>
          <span className="text-gray-600">{location.phone}</span>
        </div>
        <div className="flex items-start">
          <svg className="w-5 h-5 text-primary mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span 
            className="text-gray-600" 
            dangerouslySetInnerHTML={{ __html: location.hours.replace(/\n/g, '<br>') }}
          ></span>
        </div>
      </div>
      
      <div className="h-64 rounded-lg mb-4 overflow-hidden border border-gray-200">
        <iframe
          src={location.embedUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={`Map of ${location.name}`}
          className="bg-gray-100"
        ></iframe>
      </div>
      
      <Link 
        href={location.mapUrl} 
        target="_blank" 
        rel="noopener noreferrer"
        className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-opacity-90 transition-colors"
      >
        Get Directions
        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </Link>
    </div>
  );
};

const LocationsSection = () => {
  return (
    <section className="py-16 bg-gray-50" id="locations">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">Our Locations</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Visit our repair shops in Toronto and Mississauga for professional service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {locations.map((location) => (
            <LocationCard key={location.id} location={location} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;